import type { ConfluenceAccessLinkReleaseStage } from './__generated__/useAccessLinkReleaseStageQuery.graphql.ts';

export type AccessLinkReleaseStageFlags = {
	isAccessLinkEapEnabled: boolean;
	isAccessLinkM1Enabled: boolean;
	isAccessLinkM2Enabled: boolean;
	isAccessLinkM3Enabled: boolean;
	isAccessLinkGaEnabled: boolean;
};

// Release stages are cumulative: reaching a stage implies every earlier stage is also available.
const DISABLED_RANK = 0;
const EAP_RANK = 1;
const M1_RANK = 2;
const M2_RANK = 3;
const M3_RANK = 4;
const GA_RANK = 5;

const releaseStageRanks: Partial<Record<ConfluenceAccessLinkReleaseStage, number>> = {
	DISABLED: DISABLED_RANK,
	EAP: EAP_RANK,
	M1: M1_RANK,
	M2: M2_RANK,
	M3: M3_RANK,
	GA: GA_RANK,
};

export const getAccessLinkReleaseStageFlags = (
	stage: ConfluenceAccessLinkReleaseStage | null | undefined,
): AccessLinkReleaseStageFlags => {
	// Unresolved and unrecognised stages fall back to the disabled rank so access links stay hidden.
	const stageRank = (stage && releaseStageRanks[stage]) ?? DISABLED_RANK;

	return {
		isAccessLinkEapEnabled: stageRank >= EAP_RANK,
		isAccessLinkM1Enabled: stageRank >= M1_RANK,
		isAccessLinkM2Enabled: stageRank >= M2_RANK,
		isAccessLinkM3Enabled: stageRank >= M3_RANK,
		isAccessLinkGaEnabled: stageRank >= GA_RANK,
	};
};
